/*eslint no-unused-vars: "off"*/
import React, { useState } from 'react';
import moment from 'moment-timezone';
import { formatToCurrency } from '../../../../Tools/formatToCurrency';

const ROLE_MAPPING = {
  hurricane: 'Hurricane',
  snow_day: 'Snow Day',
  no_service: 'No Service',
  strom: 'Strom',
  promotion: 'Promotion'
};

const SERVICE_TYPE = {
  owned: 'Owned',
  serviced: 'Serviced',
  serviced_not_new: 'Serviced No New'
}

class DataTable {
  //Franchise List
  FranchiseAlerts = (self) => {
    const franchiseColumns = [
      {
        title: 'Franchise Alert',
        dataIndex: 'alert_type',
        key: 'alert_type',
        render: (text) => (<span className="type ellipse">{ROLE_MAPPING[text]}</span>)
      },
      {
        title: 'Description',
        dataIndex: 'alert_desccription',
        key: 'alert_desccription',
        width: '10%',
        className: "tdesc",
        render: (text) => (<span className="type ellipse" title={text}>{text}</span>)
      },
      {
        title: 'Start Date',
        dataIndex: 'start_date',
        key: 'start_date',
        render: (text) => (<span className="type ellipse">{moment(text).format('MM/DD/YYYY')}</span>)

      },
      {
        title: 'End Date',
        dataIndex: 'end_date',
        key: 'end_date',
        render: (text) => (<span className="type ellipse">{text ? moment(text).format('MM/DD/YYYY') : '-'}</span>)
      },
      {
        title: 'Status',
        dataIndex: 'is_active',
        key: 'is_active',
        render: (text) => (<span className="type ellipse">{text ?
          <span className="text-successs">Active</span>
          : <span style={{
            opacity: 0.5,
            color: '#1F1F25',
            fontWeight: 'bold'
          }}>Closed</span>
        }</span>)
      },
      {
        title: '',
        dataIndex: 'uuid',
        key: 'uuid',
        render: (text, record) => (

          record.is_active ?
            <div className="table_action_wrapper cursor_pointer" ref={node => { self.node = node; }}>
              <span
                className={self.state.isNav === record.uuid && self.state.openNav ? 'las la-ellipsis-v las_success' : 'las la-ellipsis-v'}
                onClick={() => { self.ShowNav(record, text) }}></span>

              <ul className={self.state.isNav === record.uuid && self.state.openNav ? 'table_Action_menu' : 'd-none'}>
                <li><span onClick={(e) => {
                  e.preventDefault();
                  self.setState({
                    new_alert: {
                      uuid: record.uuid,
                      alert_type: record.alert_type,
                      start_date: record.start_date,
                      end_date: record.end_date || '',
                      alert_desccription: record.alert_desccription,
                      untill_further_notice: record.untill_further_notice,
                    },
                    is_edit: true
                  });
                  self.ValidateAlert();
                }}>Edit</span></li>
                <li><span
                  onClick={(e) => {
                    e.preventDefault();

                    let { field_office_uuid } = self.state;
                    let new_alert = { is_active: false, uuid: record.uuid }

                    let data = { ...new_alert, field_office_uuid };

                    self.setState({
                      loader: true
                    });

                    self.props.updateFieldAlert(data);

                  }}>Close</span></li>

              </ul>

            </div >
            : ''

        )
      },

    ]
    return franchiseColumns;
  }

  FranchiseCollection = (self) => {
    return ([
      {
        title: 'Type',
        dataIndex: 'u_type',
        key: 'u_type',
        render: (text) => (<span className="type ellipse" title={text}><b>{text ? SERVICE_TYPE[text] : ''}</b></span>)
      }, {
        title: 'Zipcodes',
        dataIndex: 'zip_codes',
        key: 'zip_codes',
        render: (text) => (<span className="type ellipse">{text?.join(', ')}</span>)
      }, {
        title: 'Started Service',
        dataIndex: 'started_timestamp',
        key: 'started_timestamp',
        render: (text) => (<span className="type ellipse" title={text}>{text ? moment(text).format('YYYY, MMM') : ''}</span>)
      }, {
        title: 'Active Customers',
        dataIndex: 'active_customners',
        key: 'active_customners',
        render: (text) => (<span className="type ellipse" title={text}>{text}</span>)
      }, {
        title: 'Monthly Rev Average of last 6m',
        dataIndex: 'monthly_revenue_avg_six_months',
        key: 'monthly_revenue_avg_six_months',
        render: (text) => (<span className="type ellipse" title={text}>${text ? formatToCurrency(text) : '0'}</span>)
      }, {
        title: 'YTD Revenue',
        dataIndex: 'ytd_revenue',
        key: 'ytd_revenue',
        render: (text) => (<span className="type ellipse" title={text}>${text ? formatToCurrency(text) : '0'}</span>)
      }, {
        title: 'All Time Revenue',
        dataIndex: 'all_time_revenue',
        key: 'all_time_revenue',
        render: (text) => (<span className="type ellipse" title={text}>${text ? formatToCurrency(text) : '0'}</span>)
      }, {
        title: 'Satisfaction',
        dataIndex: 'satisfaction',
        key: 'satisfaction',
        render: (text) => (<span className="type ellipse" title={text}>{text ? formatToCurrency(text) : '0'}%</span>)
      }])
  }

  WeeklySchedule = (self) => {
    const scheduleColumns = [
      {
        title: 'Area',
        dataIndex: 'area',
        key: 'area',
        render: (text) => (<span className="type ellipse">{text}</span>)
      },
      {
        title: 'Zipcode',
        dataIndex: 'zipcode',
        key: 'zipcode',
        width: '10%',
        className: "tdesc",
        render: (text, row) => (<span className="type ellipse" title={text}>{Array.from(row.zipcode).splice(0,3).join(',')} <b>{Array.from(row.zipcode).length > 3 ? ` + ${Array.from(row.zipcode).length - 3} more` : ''}</b></span>)
      },
      {
        title: "",
        dataIndex: "manage_zipcode",
        key: "manage_zipcode",
        className: "manage_zipcode",
        sorter: false,
        render: (text, record) => (
          <div
            className="table_action_wrapper cursor_pointer"
            ref={(node) => {
              self.node = node;
            }}
          >
            <span
              className={
                self.state.openNav[record.i]
                  ? "las la-ellipsis-v las_success"
                  : "las la-ellipsis-v"
              }
              onClick={() => {
                self.ShowNav(record, text);
              }}
            ></span>

            <ul
              className={
                self.state.openNav[record.i]
                  ? "table_Action_menu text-nowrap"
                  : "d-none"
              }
            >
              <li>
                <span
                  // className={self.state.is_edit_user ? "" : "disbale_btn"}
                  onClick={(e) => {
                    e.preventDefault();
                    self.showZipcodeDrawer(true)
                    self.setState({
                      selectedRecord: record
                    });
                  }}
                >
                  Manage Zipcodes
                </span>
              </li>
            </ul>
          </div>
        ),
      },
      {
        title: 'Monday',
        dataIndex: 'monday',
        key: 'monday',
        render: (text, record) => (<span className="type ellipse"> <span onClick={(e) => {self.updateTableState({record, text, day: "mon", action: "DECEREMENT"})}} className="spin-icon spin-minus"> - </span> {text} <span onClick={(e) => {self.updateTableState({record, text, day: "mon", action: "INCREMENT"})}} className="spin-icon spin-plus"> +</span></span>)

      },
      {
        title: 'Tuesday',
        dataIndex: 'tuesday',
        key: 'tuesday',
        render: (text, record) => (<span className="type ellipse"> <span onClick={(e) => {self.updateTableState({record, text, day: "tues", action: "DECEREMENT"})}} className="spin-icon spin-minus"> - </span>{text} <span onClick={(e) => {self.updateTableState({record, text, day: "tues", action: "INCREMENT"})}} className="spin-icon spin-plus"> +</span></span>)
      },
      {
        title: 'Wednesday',
        dataIndex: 'wednesday',
        key: 'wednesday',
        render: (text, record) => (<span className="type ellipse"> <span onClick={(e) => {self.updateTableState({record, text, day: "wed", action: "DECEREMENT"})}} className="spin-icon spin-minus"> - </span> {text} <span onClick={(e) => {self.updateTableState({record, text, day: "wed", action: "INCREMENT"})}} className="spin-icon spin-plus"> +</span> </span>)
      },
      {
        title: 'Thursday',
        dataIndex: 'thursday',
        key: 'thursday',
        render: (text, record) => (<span className="type ellipse"> <span onClick={(e) => {self.updateTableState({record, text, day: "thurs", action: "DECEREMENT"})}} className="spin-icon spin-minus"> - </span> {text} <span onClick={(e) => {self.updateTableState({record, text, day: "thurs", action: "INCREMENT"})}} className="spin-icon spin-plus"> +</span> </span>)
      },
      {
        title: 'Friday',
        dataIndex: 'friday',
        key: 'friday',
        render: (text, record) => (<span className="type ellipse"> <span onClick={(e) => {self.updateTableState({record, text, day: "fri", action: "DECEREMENT"})}} className="spin-icon spin-minus"> - </span>{text}<span onClick={(e) => {self.updateTableState({record, text, day: "fri", action: "INCREMENT"})}} className="spin-icon spin-plus"> +</span> </span>)
      },
      {
        title: 'Saturday',
        dataIndex: 'saturday',
        key: 'saturday',
        render: (text, record) => (<span className="type ellipse"> <span onClick={(e) => {self.updateTableState({record, text, day: "sat", action: "DECEREMENT"})}} className="spin-icon spin-minus"> - </span> {text} <span onClick={(e) => {self.updateTableState({record, text, day: "sat", action: "INCREMENT"})}} className="spin-icon spin-plus"> +</span></span>)
      },
      {
        title: 'Sunday',
        dataIndex: 'sunday',
        key: 'sunday',
        render: (text, record) => (<span className="type ellipse"> <span onClick={(e) => {self.updateTableState({record, text, day: "sun", action: "DECEREMENT"})}} className="spin-icon spin-minus"> - </span> {text} <span onClick={(e) => {self.updateTableState({record, text, day: "sun", action: "INCREMENT"})}} className="spin-icon spin-plus"> + </span></span>)
      }

    ]
    return scheduleColumns;
  }

  FutureSchedule = (self) => {

    const today = new Date();
    
    const convertDateToString = (date) => {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
    
      return [year, month, day].join('-');
    };

    
    // function to get the string in the format of DAY, Month DD
    const getTitle = (date) => {
      let day = date.getDay();
      let month = date.getMonth();
      let dayOfMonth = date.getDate();
      let monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      return `${["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][day]}, ${monthNames[month]} ${dayOfMonth}`;
    };
    
    // function to add a day to the date
    const addDay = (date, days) => {
      let result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    };
    
    const row = [...Array(10).keys()].map((i) => {
      return convertDateToString(addDay(today, i));
    });

    const scheduleColumns = [
      {
        title: 'Area',
        dataIndex: 'area',
        key: 'area',
        render: (text) => (<span className="type ellipse">{text}</span>)
      },
      ...row.map((day, index)=> ({
        title: getTitle(addDay(today, index)),
        dataIndex: day,
        key: day,
        render: (text, record) => {
          return (<NextTenDaysCell record={record} day={day} self={self}/>)
        }
      })),
      // {
      //   title: 'Tuesday',
      //   dataIndex: 'tuesday',
      //   key: 'tuesday',
      //   render: (text) => (<span className="type ellipse fill-badge fully-filled-services"> 5/5 filled</span>)
      // },
      // {
      //   title: 'Wednesday',
      //   dataIndex: 'wednesday',
      //   key: 'wednesday',
      //   render: (text) => (<span className="type ellipse fill-badge partly-filled-services">4/5 filled </span>)
      // },
      // {
      //   title: 'Thursday',
      //   dataIndex: 'thursday',
      //   key: 'thursday',
      //   render: (text) => (<span className="type ellipse fill-badge partly-filled-services"> 2/3 filled </span>)
      // },
      // {
      //   title: 'Friday',
      //   dataIndex: 'friday',
      //   key: 'friday',
      //   render: (text) => (<span className="type ellipse fill-badge empty-services"> 0/4 filled </span>)
      // },
      // {
      //   title: 'Saturday',
      //   dataIndex: 'saturday',
      //   key: 'saturday',
      //   render: (text) => (<span className="type ellipse fill-badge empty-services">  0/7 filled</span>)
      // },
      // {
      //   title: 'Sunday',
      //   dataIndex: 'sunday',
      //   key: 'sunday',
      //   render: (text) => (<span className="type ellipse fill-badge partly-filled-services">  3/7 filled </span>)
      // }

    ]
    return scheduleColumns;
  }
}

function NextTenDaysCell({record, day, self}) {
  const [totalClean, setTotalClean] = useState(record[day]?.total_clean);

  const percentage = (record[day]?.filled_clean/record[day]?.total_clean) * 100 || 0;

  return (
    // COLOR SCHEME:
    // 100% red
    // 50% + organge
    // <50 green
    <div className="badge-grp">
      <span className={`type ellipse com fill-badge ${(percentage < 50) ? "empty-services" : (percentage >= 50 && percentage < 100) ? "partly-filled-services" : "fully-filled-services"}`}> {record[day]?.filled_clean || 0}/{record[day]?.total_clean} filled </span>
      <div className="badge-setting">
        <span className="badge-setting-icon"></span>
        <div className="setting-popover">
          <div className="flex ai-center">
            <span className="type ellipse"> 
              <span onClick={() => {setTotalClean(x => (x - 1 > 0 ? x - 1 : 0))}} className="spin-icon spin-minus"> - </span> 
              {totalClean}
              <span onClick={() => {setTotalClean(x => x + 1)}} className="spin-icon spin-plus"> +</span>
            </span>
            <button onClick={() => {
              if(self?.props?.updateCleaningField) {
                self.props.updateCleaningField({
                  UUID: record[day].uuid,
                  params: {
                    total_clean: totalClean
                  }
                });
              }
            }}className="btn btn-warning">Update</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default new DataTable();